import type { SVGProps } from "react";
const SvgCommunityPostTypeIntroduction = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 15 15"
    fontSize="1rem"
    {...props}
  >
    <path
      fill="#88C8ED"
      d="M13.982 5.035a.39.39 0 0 1-.366-.247 6.6 6.6 0 0 0-1.764-2.497.393.393 0 0 1 .52-.59 7.4 7.4 0 0 1 1.975 2.795.393.393 0 0 1-.365.54M1.123 8.667a.39.39 0 0 1-.386-.325 7.37 7.37 0 0 1 .341-3.825.393.393 0 1 1 .738.273 6.6 6.6 0 0 0-.305 3.416.393.393 0 0 1-.388.461M3.773 10.029c.005.004.588.509.822.799.699.867 2.826 3.505 5.591 2.224 1.049-.486 1.7-1.09 1.99-1.848a3.6 3.6 0 0 0-.058-2.776L9.96 3.65a.57.57 0 0 0-.757-.29.57.57 0 0 0-.29.757l1.148 2.655a.246.246 0 0 1-.45.198L7.836 2.993a.53.53 0 0 0-.696-.267l-.084.037a.524.524 0 0 0-.286.648L8.41 7.093a.246.246 0 1 1-.449.2L5.94 2.756a.524.524 0 0 0-.697-.267l-.084.037a.524.524 0 0 0-.267.697l1.958 4.36a.246.246 0 1 1-.45.2L4.94 4.504a.524.524 0 0 0-.697-.267l-.083.038a.524.524 0 0 0-.268.696l1.777 3.985 1.21.849a.246.246 0 0 1-.282.402L4.66 8.85a.74.74 0 0 0-1.038.147.73.73 0 0 0-.139.547.73.73 0 0 0 .29.486"
    />
  </svg>
);
export default SvgCommunityPostTypeIntroduction;
